import { Box } from '@csscompany/csds-components';
import React from 'react';

export const LoadingState = () => (
  <Box
    id="loading-state"
    backgroundColor="$staticBackgroundStandard"
    className="zIndex-10 fixed !h-screen !w-screen text-center">
    <Box className="inset-0 mt-[30%]">
      <div
        className="border-current inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-r-transparent align-[-0.125em] text-secondary motion-reduce:animate-[spin_1.5s_linear_infinite]"
        role="status">
        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
          Loading...
        </span>
      </div>
    </Box>
  </Box>
);
